import { css } from 'styled-components'

export default {
  H1: css`
    color: #404040;
    margin-bottom: 5px;
    margin-top: 5px;
    padding-bottom: 20px;
    padding-top: 0;
  `,
}
